module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"watchNow":"WATCH NOW","back":"Back"},"es":{"watchNow":"Ver ahora","back":"Atrás"},"pt":{"watchNow":"Assistir agora","back":"Voltar"}}')
  delete Component.options._Ctor
}
